import { Task } from '@/types/employee/task';
import dayjs from 'dayjs';

export const tasks: Task[] = [
  {
    id: 'TASK001',
    title: 'Corrigir torneira com vazamento na Unidade 101',
    description: 'Residente relatou uma torneira com vazamento no banheiro',
    type: 'maintenance',
    status: 'in_progress',
    priority: 'high',
    assignedTo: {
      id: 'EMP001',
      name: 'Miguel Johnson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'João Silva'
    },
    dueDate: dayjs('2024-03-20').toDate(),
    apartmentUnit: {
      id: 'UNIT001',
      name: 'Unidade 101'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'Foto do Vazamento',
        type: 'image/jpeg',
        size: 1024,
        path: '/documents/tasks/TASK001/leak.jpg',
        url: '/documents/tasks/TASK001/leak.jpg',
        uploadedAt: dayjs('2024-03-15').toDate()
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK002',
    title: 'Limpar lobby da área comum',
    description: 'Limpeza diária da área principal do lobby',
    type: 'cleaning',
    status: 'completed',
    priority: 'medium',
    assignedTo: {
      id: 'EMP002',
      name: 'Sara Wilson'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'João Silva'
    },
    dueDate: dayjs('2024-03-19').toDate(),
    completedAt: dayjs('2024-03-19').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK003',
    title: 'Patrulha de segurança - Edifício A',
    description: 'Patrulha de segurança noturna ao redor do perímetro do Edifício A',
    type: 'security',
    status: 'pending',
    priority: 'high',
    assignedTo: {
      id: 'EMP003',
      name: 'David Brown'
    },
    assignedBy: {
      id: 'ADM002',
      name: 'Amanda Martinez'
    },
    dueDate: dayjs('2024-03-21').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'TASK004',
    title: 'Inspecionar extintores de incêndio',
    description: 'Inspeção mensal de todos os extintores de incêndio no edifício',
    type: 'inspection',
    status: 'in_progress',
    priority: 'urgent',
    assignedTo: {
      id: 'EMP004',
      name: 'Roberto Taylor'
    },
    assignedBy: {
      id: 'ADM001',
      name: 'João Silva'
    },
    dueDate: dayjs('2024-03-22').toDate(),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 